import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomUpload from "../../../components/CustomUpload";
import { default as Select } from "../../../components/Select/Select";
import SplitButton from "../../../components/SplitButtion";
import { soapApi } from "../../../redux/actions/api";
import {
  deleteStockById,
  deleteStockByIds,
  getLocations,
  getPendingStocksByClinic,
  getStocksByClinic,
  updateStockFilesById,
  updateStockWithBatchList,
} from "../../../redux/reducers/clinicSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import { AppColors } from "../../../util/AppColors";
import { drugScheduleShowCategoryList } from "../../../util/arrayList";
import { addIcon, plusBtn } from "../../../util/CommonIconStyle";
import {
  administeredUOMList,
  dosageTypes,
  drugScheduleList,
  productCategoryList,
} from "../../../util/dropList";
import { getExactNumber, normalizeDate } from "../../../util/function";
import { tblGrayBack } from "../../../util/object";
import FilesWithCloseButton from "../ClinicPetDetails/PatientWorkbook/FilesWithCloseButton";

const requiredFieldList = [
  "category",
  "subCategory",
  "name",
  "tradeName",
  // "code",
  // "location",
  // "unitSellingPrice",
  // "quantity",
  // "adminUom",
  // "landedCost",
  "cgst",
  "sgst",
  // "itemTotal",
];

const batchRequiredFields = [
  "location",
  "quantity",
  "subunits",
  "unitSellingPrice",
];

const nmeExpan = {
  hsnSacCode: "HSN Code",
  name: "Name",
  quantity: "Qty",
  landedCost: "Landed Cost",
  cgst: "CGST %",
  sgst: "SGST %",
  taxes: "Taxes",
  itemTotal: "Item Total",
  purchaseUom: "UOM",
};

const initStckVal = { supplierName: null, date: new Date(), list: [] };
const initialValues = {
  category: null,
  subCategory: "",
  name: "",
  tradeName: "",
  ingredient: "",
  nature: null,
  code: "",
  brand: "",
  batchNumber: "",
  manufacturingDate: null,
  expiryDate: null,
  location: null,
  unitSellingPrice: "",
  description: "",
  billable: "Y",
  autoConsumed: false,
  active: true,
  purchaseUom: "",
  salesUom: "",
  conversionFactor: "",
  subunits: "",
};
const initialError = {
  category: false,
  subCategory: false,
  name: false,
  tradeName: false,
  ingredient: false,
  nature: false,
  code: false,
  brand: false,
  batchNumber: false,
  manufacturingDate: false,
  expiryDate: false,
  location: false,

  unitSellingPrice: false,

  description: false,
};

const initialHelp = {
  category: "",
  subCategory: "",
  name: "",
  tradeName: "",
  ingredient: "",
  nature: "",
  code: "",
  brand: "",
  batchNumber: "",
  manufacturingDate: "",
  expiryDate: "",
  location: "",

  unitSellingPrice: "",

  description: "",
};

const stckEntTblHdrs = [
  "selected",
  "hsnSacCode",
  "name",
  "quantity",
  "purchaseUom",
  "landedCost",
  "cgst",
  "sgst",
  "taxes",
  "itemTotal",
  "status",
];

const initBatch = {
  batchNumber: "",
  manufacturingDate: null,
  expiryDate: null,
  location: null,
  quantity: "",
  subunits: "",
  unitSellingPrice: "",
  landedCost: "",
};

const StockPendingTable = ({ setPenTblVsble }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [stckValue, setStckValue] = useState(initStckVal);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [invntUpdModVsble, setInvntUpdModVsble] = useState(false);
  const [inventFiles, setInventFiles] = useState([]);
  const [delModVsble, setDelModVsble] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [prdctPrevModVsble, setPrdctPrevModVsble] = useState(false);
  const [productErrors, setProductErrors] = useState(initialError);
  const [productHelps, setProductHelps] = useState(initialHelp);
  const [productValues, setProductValues] = useState(initialValues);
  const [batchValues, setBatchValues] = useState({});
  const [batchErrs, setBatchErrs] = useState({});
  const [batchHelps, setBatchHelps] = useState({});
  const pendingStocks = useSelector((state) => state?.clinic?.pendingStocks);
  const locationList = useSelector((state) => state?.clinic?.locationList);
  const itemSize = 10;
  const defaultUrl = `?type=pending&page=1&itemSize=${itemSize}&search=${searchValue}`;

  useEffect(() => {
    dispatch(getPendingStocksByClinic(defaultUrl));
    dispatch(getLocations());
  }, []);

  useEffect(() => {
    dispatch(
      getPendingStocksByClinic(
        `?type=pending&page=1&itemSize=${itemSize}&search=${searchValue}`,
      ),
    );
    setPage(1);
  }, [searchValue]);

  useEffect(() => {
    getTableList();
  }, [pendingStocks?.data]);

  const getLocationList = () => {
    if (locationList?.length === 0 || !locationList) return [];
    return locationList?.map((loc) => ({
      name: loc?.locationName,
      value: loc?.locationName,
      id: loc?.id,
    }));
  };

  const getTableList = () => {
    const list = pendingStocks?.data?.map((itm, i) => {
      const batch = itm?.stockBatch?.[0];
      return {
        ...itm,
        purchaseUom: batch?.purchaseUom,
        landedCost: Number(batch?.landedCost)?.toFixed(2),
        cgst: batch?.cgst,
        sgst: batch?.sgst,
        taxes: Number(batch?.taxes)?.toFixed(2),
        itemTotal: Number(batch?.itemTotal)?.toFixed(2),
        name: itm?.tradeName,
        i,
        apiCalled: false,
        backEndApiCalled: false,
        selected: false,
      };
    });
    setStckValue({ ...stckValue, list });
    setFilteredList(list);
  };

  const handleApiCall = () => {
    const prdct = productValues?.product;
    dispatch(showLoader());
    // const product = {
    //   description: prdct?.description ?? "",
    //   packageUom: `${prdct?.packageUom}${prdct?.adminUom?.value}`,
    //   purchaseUom: prdct?.purchaseUom,
    //   dosage: prdct?.dosage ?? "",
    //   dosageType: prdct?.dosageType?.value ?? null,
    //   salesUom: prdct?.salesUom ?? "",
    //   conversionFactor: prdct?.conversionFactor ?? "1",
    //   billable: prdct?.billable ? "Y" : "N",
    //   subunits:
    //     Number(prdct?.subunits) ??
    //     Number(prdct?.quantity ?? 1) * Number(prdct?.conversionFactor ?? 1),
    //   // barCodeNo: prdct?.code ?? "",
    //   batchNumber: prdct?.["BatchNumber"] ?? prdct?.["batchNumber"] ?? "",
    //   brand: prdct?.brand ?? "",
    //   category: prdct?.category?.value ?? prdct?.category ?? "",
    //   expiryDate: moment(new Date(prdct?.expiryDate ?? prdct?.expDate)).format(
    //     "YYYY-MM-DD"
    //   ),
    //   mfgDate: moment(
    //     new Date(prdct?.mfgDate ?? prdct?.manufacturingDate ?? new Date())
    //   ).format("YYYY-MM-DD"),
    //   // prodcutName: prdct?.name ?? "",
    //   productName: prdct?.name ?? "",
    //   hsnSacCode: prdct?.hsnSacCode ?? "",
    //   uqcCode: prdct?.uqcCode ?? "",
    //   tradeName: prdct?.tradeName ?? "",
    //   ingredient: prdct?.ingredient ?? "",
    //   nature: prdct?.nature ?? "",
    //   type: prdct?.type ?? "",
    //   taxes: Number(
    //     getExactNumber(prdct?.taxes ?? selectedRowData?.taxes) ?? 0
    //   ),
    //   tax: Number(getExactNumber(prdct?.taxes ?? selectedRowData?.taxes) ?? 0),
    //   subCategory: prdct?.subCategory ?? "",
    //   unitSellingPrice: Number(getExactNumber(prdct?.unitSellingPrice) ?? 0),
    //   location: prdct?.location?.id ?? prdct?.location ?? "",
    //   active: true,
    //   // active: !prdct?.active,
    //   landedCost:
    //     Number(Number(prdct?.itemTotal) / Number(prdct?.subunits)) ??
    //     Number(getExactNumber(prdct?.landedCost)) ??
    //     0,
    //   internalDescription: prdct?.internalDescription,
    //   productVector: prdct?.productVector,
    //   invoiceName:
    //     prdct?.stockPrevName ??
    //     productValues?.stockPrevName ??
    //     selectedRowData?.name ??
    //     "",
    //   reorderLevel: prdct?.reorderLevel,
    //   drugSchedule: prdct?.drugSchedule?.value ?? "",
    // };
    // const stockObj = {
    //   hsnSacCode: prdct?.hsnSacCode,
    //   tradeName: prdct?.tradeName ?? selectedRowData?.tradeName,
    //   quantity: Number(
    //     getExactNumber(prdct?.quantity ?? selectedRowData?.quantity) ?? 1
    //   ),
    //   cgst: Number(getExactNumber(prdct?.cgst ?? selectedRowData?.cgst) ?? 0),
    //   sgst: Number(getExactNumber(prdct?.sgst ?? selectedRowData?.sgst) ?? 0),
    //   taxes: Number(
    //     getExactNumber(prdct?.taxes ?? selectedRowData?.taxes) ?? 0
    //   ),
    //   itemTotal: Number(
    //     getExactNumber(prdct?.itemTotal ?? selectedRowData?.itemTotal) ?? 0
    //   ),
    //   landedCost:
    //     Number(
    //       getExactNumber(prdct?.landedCost ?? selectedRowData?.landedCost) ?? 0
    //     ) ?? 0,
    //   barCodeNo: prdct?.code ?? "",
    //   status: true,
    //   product,
    //   stockId: selectedRowData?.stockId,
    //   reorderLevel: prdct?.reorderLevel,
    //   drugSchedule: prdct?.drugSchedule?.value ?? "",
    // };
    // if (
    //   !selectedRowData?.stockBatch?.[0]?.batchNo ||
    //   selectedRowData?.stockBatch?.[0]?.batchNo === null
    // ) {
    //   stockObj.batchId = selectedRowData?.stockBatch?.[0]?.batchId;
    // }

    const reqBatchList = productValues?.batchList?.map((bat) => {
      const reqObj = {
        batchId: bat?.batchId ?? null,
        packageUom: `${prdct?.packageUom}${prdct?.adminUom?.value}`,
        dosage: prdct?.dosage ?? "",
        dosageType: prdct?.dosageType?.value ?? null,
        purchaseUom: prdct?.purchaseUom,
        salesUom: prdct?.salesUom ?? "",
        conversionFactor: prdct?.conversionFactor ?? "1",
        subunits:
          Number(bat?.subunits) ??
          Number(bat?.quantity ?? 1) * Number(prdct?.conversionFactor ?? 1),
        quantity: Number(getExactNumber(bat?.quantity) ?? 1),
        barCodeNo: prdct?.code ?? "",
        description: prdct?.description ?? "",
        batchNumber: bat?.batchNumber,
        brand: prdct?.brand ?? "",
        category: prdct?.category?.value ?? prdct?.category ?? "",
        mfgDate: moment(new Date(bat?.manufacturingDate ?? new Date())).format(
          "YYYY-MM-DD",
        ),
        expiryDate: moment(new Date(bat?.expiryDate ?? new Date())).format(
          "YYYY-MM-DD",
        ),
        productName: prdct?.name ?? "",
        hsnSacCode: prdct?.hsnSacCode,
        uqcCode: prdct?.uqcCode ?? "",
        tradeName: prdct?.tradeName ?? selectedRowData?.tradeName,
        ingredient: prdct?.ingredient ?? "",
        nature: prdct?.nature ?? "",
        type: "",
        taxes: 0,
        tax: 0,
        subCategory: prdct?.subCategory ?? "",
        unitSellingPrice: Number(
          getExactNumber(bat?.unitSellingPrice) ?? 0,
        )?.toFixed(2),
        location: bat?.location?.id,
        landedCost: Number(bat?.landedCost ?? 0),
      };
      return reqObj;
    });
    const data = {
      multipleBatch: reqBatchList,
      skuId: prdct?.skuId ?? "",
      active: prdct?.active,
      autoConsumed: prdct?.autoConsumed,
      billable: prdct?.billable,
      ingredient: prdct?.ingredient ?? "",
      description: prdct?.description ?? "",
      brand: prdct?.brand ?? "",
      barCodeNo: prdct?.code ?? "",
      productName: prdct?.name ?? "",
      hsnSacCode: prdct?.hsnSacCode,
      uqcCode: prdct?.uqcCode ?? "",
      tradeName: prdct?.tradeName ?? selectedRowData?.tradeName,
      category: prdct?.category?.value ?? prdct?.category ?? "",
      subCategory: prdct?.subCategory ?? "",
      nature: prdct?.nature ?? "",
      packageUom: `${prdct?.packageUom}${prdct?.adminUom?.value}`,
      dosage: prdct?.dosage ?? "",
      dosageType: prdct?.dosageType?.value ?? null,
      purchaseUom: prdct?.purchaseUom,
      salesUom: prdct?.salesUom ?? "",
      conversionFactor: prdct?.conversionFactor ?? "1",
      cgst: Number(getExactNumber(prdct?.cgst ?? selectedRowData?.cgst) ?? 0),
      sgst: Number(getExactNumber(prdct?.sgst ?? selectedRowData?.sgst) ?? 0),
      itemTotal: Number(
        getExactNumber(prdct?.itemTotal ?? selectedRowData?.itemTotal) ?? 0,
      ),
      landedCost: Number(productValues?.batchList?.[0]?.landedCost ?? 0),
      reorderLevel: prdct?.reorderLevel,
      drugSchedule: prdct?.drugSchedule?.value ?? "",
      status: true,
      productVector: prdct?.productVector ?? [],
      invoiceName: prdct?.stockPrevName ?? selectedRowData?.name ?? "",
    };
    try {
      // updateStocks({ stocks: [stockObj] })
      dispatch(
        updateStockWithBatchList({ stockId: selectedRowData?.stockId, data }),
      ).then((res) => {
        if (res?.payload) {
          const reqList = stckValue?.list?.map((li, i) => {
            if (i === selectedRowData?.i) {
              return {
                ...li,
                apiCalled: true,
                backEndApiCalled: true,
                name: prdct?.tradeName,
              };
            }
            return li;
          });
          dispatch(getPendingStocksByClinic(defaultUrl));
          setStckValue({ ...stckValue, list: reqList });
          const fileForm = new FormData();
          inventFiles?.forEach((fle) => {
            fileForm.append("stockFiles", fle?.file);
          });
          dispatch(
            updateStockFilesById({
              stockId: selectedRowData?.stockId,
              form: fileForm,
            }),
          );
          setInventFiles([]);
          setInvntUpdModVsble(false);
          setSelectedRowData(null);
          setPrdctPrevModVsble(false);
          setProductErrors(initialError);
          setProductHelps(initialHelp);
        }
      });
    } catch (err) {
      dispatch(hideLoader());
      console.log("Err");
    }
  };

  const handleUploadInventry = (data) => {
    setSelectedRowData(data);
    setInvntUpdModVsble(true);
  };

  const handleBack = () => {
    dispatch(getStocksByClinic(`?page=1&itemSize=10`));
    setPenTblVsble(false);
  };

  const handleInventImageRemove = (ind) => {
    const reqList = inventFiles
      ?.filter((fle, i) => i !== ind)
      ?.map((fle, i) => ({ ...fle, i }));
    setInventFiles(reqList);
  };

  const getLocationById = (locId = null) => {
    if (locId) return null;
    const locMat = locationList?.find((loc) => loc?.id === locId);
    return {
      name: locMat?.locationName,
      value: locMat?.locationName,
      id: locMat?.id,
    };
  };

  const onInventoryUpload = () => {
    if (inventFiles?.length === 0 || !inventFiles) return;
    dispatch(showLoader());
    const form = new FormData();
    inventFiles?.forEach((fle) => {
      form.append("files", fle?.file);
    });
    if (selectedRowData?.purchaseUom?.length > 0) {
      form.append("purchase_uom", selectedRowData?.purchaseUom);
    }
    soapApi
      .post("/inventory", form)
      .then((apiRes) => {
        if (apiRes?.status === 200) {
          const reqDta = apiRes?.data?.extracted_data;
          const subunits =
            Number(selectedRowData?.quantity) *
            Number(reqDta?.ConversionFactor ?? 1);
          setPrdctPrevModVsble(true);
          const isBatchAvailable = selectedRowData?.stockBatch?.length > 0;
          const batchList = isBatchAvailable
            ? selectedRowData?.stockBatch?.map((bat, i) => {
                const reqLocation = getLocationById(bat?.locationId);
                const reqObj = {
                  batchId: bat?.batchId ?? null,
                  i,
                  batchNumber:
                    i === 0
                      ? (reqDta?.BatchNumber ?? "")
                      : (bat?.batchNo ?? ""),
                  manufacturingDate:
                    i === 0
                      ? reqDta?.ManufacturingDate &&
                        reqDta?.ManufacturingDate?.length > 0
                        ? new Date(normalizeDate(reqDta?.ManufacturingDate))
                        : new Date()
                      : bat?.mfgDate
                        ? new Date(normalizeDate(bat?.mfgDate))
                        : new Date(),
                  expiryDate:
                    i === 0
                      ? reqDta?.ExpiryDate && reqDta?.ExpiryDate?.length > 0
                        ? new Date(normalizeDate(reqDta?.ExpiryDate))
                        : new Date()
                      : bat?.expiryDate
                        ? new Date(normalizeDate(bat?.expiryDate))
                        : new Date(),
                  location: reqLocation,
                  quantity: bat?.quantity,
                  subunits:
                    Number(
                      Number(bat?.quantity) *
                        Number(reqDta?.ConversionFactor ?? 1),
                    ) ?? 1,
                  unitSellingPrice:
                    i === 0
                      ? Number(
                          getExactNumber(reqDta?.UnitSellingPrice),
                        )?.toFixed(2)
                      : Number(bat?.unitSellingPrice ?? 0)?.toFixed(2),
                  landedCost: bat?.landedCost ?? 0,
                };
                return reqObj;
              })
            : [
                {
                  ...initBatch,
                  i: 0,
                  batchNumber: reqDta?.BatchNumber ?? "",
                  manufacturingDate:
                    reqDta?.ManufacturingDate &&
                    reqDta?.ManufacturingDate?.length > 0
                      ? new Date(normalizeDate(reqDta?.ManufacturingDate))
                      : new Date(),
                  expiryDate:
                    reqDta?.ExpiryDate && reqDta?.ExpiryDate?.length > 0
                      ? new Date(normalizeDate(reqDta?.ExpiryDate))
                      : new Date(),
                  location: null,
                  quantity: selectedRowData?.quantity,
                  subunits:
                    Number(
                      Number(selectedRowData?.quantity) *
                        Number(reqDta?.ConversionFactor ?? 1),
                    ) ?? 1,
                  unitSellingPrice: Number(
                    getExactNumber(reqDta?.UnitSellingPrice ?? 0),
                  )?.toFixed(2),
                  landedCost: selectedRowData?.landedCost,
                },
              ];
          setBatchValues({
            batchNumber: reqDta?.BatchNumber ?? "",
            manufacturingDate:
              reqDta?.ManufacturingDate && reqDta?.ManufacturingDate?.length > 0
                ? new Date(normalizeDate(reqDta?.ManufacturingDate))
                : isBatchAvailable && selectedRowData?.stockBatch?.[0]?.mfgDate
                  ? new Date(
                      normalizeDate(selectedRowData?.stockBatch?.[0]?.mfgDate),
                    )
                  : new Date(),
            expiryDate:
              reqDta?.ExpiryDate && reqDta?.ExpiryDate?.length > 0
                ? new Date(normalizeDate(reqDta?.ExpiryDate))
                : isBatchAvailable &&
                    selectedRowData?.stockBatch?.[0]?.expiryDate
                  ? new Date(
                      normalizeDate(
                        selectedRowData?.stockBatch?.[0]?.expiryDate,
                      ),
                    )
                  : new Date(),
            location: isBatchAvailable
              ? getLocationById(selectedRowData?.stockBatch?.[0]?.locationId)
              : null,
            quantity: isBatchAvailable
              ? selectedRowData?.stockBatch?.[0]?.quantity
              : selectedRowData?.quantity,
            subunits:
              Number(
                Number(
                  isBatchAvailable
                    ? selectedRowData?.stockBatch?.[0]?.quantity
                    : selectedRowData?.quantity,
                ) * Number(reqDta?.ConversionFactor ?? 1),
              ) ?? 1,
            unitSellingPrice: Number(
              getExactNumber(
                reqDta?.UnitSellingPrice ??
                  selectedRowData?.stockBatch?.[0]?.unitSellingPrice,
              ) ?? 0,
            )?.toFixed(2),
            landedCost: isBatchAvailable
              ? selectedRowData?.stockBatch?.[0]?.landedCost
              : selectedRowData?.landedCost,
          });
          setProductValues({
            ...productValues,
            stockPrevName: selectedRowData?.name,
            apiResponse: JSON.stringify(reqDta),
            isBatchEdit: true,
            activeBatchIndex: 0,
            batchList,
            product: {
              ...productValues,
              ...selectedRowData,
              ...reqDta,
              skuId: reqDta?.skuId ?? selectedRowData?.skuId ?? "",
              billable: true,
              stockPrevName: selectedRowData?.name,
              quantity: selectedRowData?.quantity,
              landedCost: selectedRowData?.landedCost,
              itemTotal: selectedRowData?.itemTotal,
              packageUom: reqDta?.AdministeredTotalUnits ?? "",
              adminUom:
                administeredUOMList?.find(
                  (al) =>
                    al?.value?.toLowerCase() ===
                    reqDta?.AdministeredUOM?.toLowerCase(),
                ) ?? administeredUOMList?.[0],
              active: true,
              subunits,
              conversionFactor: reqDta?.ConversionFactor,
              hsnSacCode: reqDta?.HSNCode,
              batchNumber: reqDta?.BatchNumber,
              uqcCode: reqDta?.UQCCode ?? "",
              category:
                productCategoryList?.find(
                  (prd) => prd?.value === reqDta?.Category,
                ) ?? null,
              subCategory: reqDta?.SubCategory ?? null,
              ingredient: reqDta?.MajorActiveIngredients,
              nature: reqDta?.Nature ?? "",
              code: reqDta?.BarCodeNumber,
              brand: reqDta?.Brand,
              salesUom: reqDta?.Saleuom,
              manufacturingDate:
                reqDta?.ManufacturingDate &&
                reqDta?.ManufacturingDate?.length > 0
                  ? new Date(normalizeDate(reqDta?.ManufacturingDate))
                  : new Date(),
              expiryDate:
                reqDta?.ExpiryDate && reqDta?.ExpiryDate?.length > 0
                  ? new Date(normalizeDate(reqDta?.ExpiryDate))
                  : new Date(),
              location: null,
              description: reqDta?.BriefDescription,
              unitSellingPrice: Number(
                getExactNumber(reqDta?.UnitSellingPrice) ?? 0,
              )?.toFixed(2),
              oldSellingPrice: getExactNumber(reqDta?.UnitSellingPrice),
              tradeName: reqDta?.TradeName,
              name: reqDta?.Name,
              landedCost: Number(
                (Number(selectedRowData?.itemTotal) ?? 0) / Number(subunits) ??
                  1,
              ),
              dosage: reqDta?.Dosage ?? "",
              dosageType: dosageTypes?.[0],
              internalDescription: reqDta?.InternalDescription ?? "",
              productVector: reqDta?.ProductVector ?? [],
              reorderLevel: "",
              drugSchedule: null,
            },
          });
          dispatch(hideLoader());
        } else {
          dispatch(hideLoader());
        }
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(hideLoader());
      });
  };

  const handleCloseInvntUpload = () => {
    setInvntUpdModVsble(false);
    setInventFiles([]);
  };

  const handleDeleteRow = (dta) => {
    setSelectedRowData(dta);
    setDelModVsble(true);
  };

  const handleCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedRowData(null);
  };

  const handleConfirmDelete = () => {
    dispatch(deleteStockById(selectedRowData?.stockId)).then((res) => {
      if (res?.payload) {
        dispatch(getPendingStocksByClinic(defaultUrl));
        handleCloseDelMod();
      }
    });
  };

  const onUploadFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists = inventFiles?.length > 0 ? [...inventFiles] : [];

    const readFiles = Array.from(fileList).map((file, i) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
              i,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => setInventFiles(fileLists))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const onClosePrevMod = () => {
    setPrdctPrevModVsble(false);
    setSelectedRowData(null);
    setProductErrors(initialError);
    setProductHelps(initialHelp);
  };

  const handleChange = (name, value) => {
    const prdObj = { ...productValues?.product, [name]: value };
    if (name === "cgst" || name === "sgst") {
      prdObj.cgst = value;
      prdObj.sgst = value;
    }
    if (name === "conversionFactor") {
      prdObj.subunits =
        Number(value) * Number(productValues?.product?.quantity);
      prdObj.unitSellingPrice =
        Number(prdObj?.oldSellingPrice ?? prdObj?.unitSellingPrice ?? 0) /
        Number(value);
    }
    if (name === "quantity") {
      prdObj.subunits =
        Number(productValues?.product?.conversionFactor) * Number(value);
      prdObj.unitSellingPrice =
        Number(prdObj?.oldSellingPrice ?? prdObj?.unitSellingPrice ?? 0) /
        Number(value);
      prdObj.landedCost =
        Number(productValues?.product?.itemTotal) /
        (Number(productValues?.product?.conversionFactor) * Number(value));
    }
    if (name === "unitSellingPrice") {
      prdObj.oldSellingPrice = value;
    }
    setProductValues({ ...productValues, product: prdObj });
    const reqValue = typeof value === "object" ? value?.value : value;
    if (reqValue?.length > 0) {
      setProductErrors({ ...productErrors, [name]: false });
      setProductHelps({ ...productHelps, [name]: "" });
    } else {
      setProductErrors({
        ...productErrors,
        [name]: requiredFieldList?.includes(name)
          ? name === "manufacturingDate" || name === "expiryDate"
            ? false
            : true
          : false,
      });
      setProductHelps({
        ...productHelps,
        [name]: requiredFieldList?.includes(name)
          ? name === "manufacturingDate" || name === "expiryDate"
            ? ""
            : "This field is required"
          : "",
      });
    }
  };

  const handleSubmit = async () => {
    let errObj = {};
    let hlpObj = {};
    requiredFieldList?.forEach((fld) => {
      const reqValue =
        typeof productValues?.product?.[fld] === "object"
          ? productValues?.product?.[fld]?.value
          : productValues?.product?.[fld];

      if (
        reqValue === undefined ||
        reqValue === null ||
        reqValue?.length === 0 ||
        reqValue === ""
      ) {
        errObj = {
          ...errObj,
          [fld]: requiredFieldList?.includes(fld)
            ? fld === "manufacturingDate" || fld === "expiryDate"
              ? false
              : fld === "unitSellingPrice"
                ? !productValues?.product?.billable
                  ? false
                  : true
                : true
            : false,
        };
        hlpObj = {
          ...hlpObj,
          [fld]: requiredFieldList?.includes(fld)
            ? fld === "manufacturingDate" || fld === "expiryDate"
              ? ""
              : fld === "unitSellingPrice"
                ? !productValues?.billable
                  ? ""
                  : "This field is required"
                : "This field is required"
            : "",
        };
      } else {
        errObj = { ...errObj, [fld]: false };
        hlpObj = { ...hlpObj, [fld]: "" };
      }
    });
    setProductErrors({ ...productErrors, ...errObj });
    setProductHelps({ ...productHelps, ...hlpObj });
    if (
      Object.keys(errObj)?.some((val) => errObj?.[val] === true) ||
      productValues?.batchList?.length === 0 ||
      !productValues?.batchList ||
      typeof productValues?.activeBatchIndex === "number"
    ) {
      if (typeof productValues?.activeBatchIndex === "number") {
        alert("Save or Update the current batch");
      }
      return;
    }
    handleApiCall();
  };

  const handleChangePage = (e, selectedPage) => {
    dispatch(
      getPendingStocksByClinic(
        `?type=pending&page=${selectedPage}&itemSize=${itemSize}&search=${searchValue}`,
      ),
    );
    setPage(selectedPage);
  };

  const handleChangeCheckBox = (value, ind) => {
    const reqList = filteredList?.map((li, i) => {
      if (i === ind) {
        return { ...li, selected: value };
      }
      return li;
    });
    setFilteredList(reqList);
  };

  const handleMultiDelete = () => {
    if (!filteredList?.find((li) => li?.selected)) return;
    const stockIds = filteredList
      ?.filter((li) => li?.selected)
      ?.map((li) => li?.stockId);
    dispatch(deleteStockByIds({ stockIds })).then((res) => {
      if (res?.payload) {
        dispatch(getPendingStocksByClinic(defaultUrl));
        setPage(1);
      }
    });
  };

  const handleAction = (value) => {
    if (!filteredList?.find((li) => li?.selected)) return;
    if (value === "Delete") {
      handleMultiDelete();
    }
  };

  const handleCheckAll = () => {
    const reqSel = filteredList?.filter((li) => li?.selected === true);
    const reqList = filteredList?.map((li) => ({
      ...li,
      selected: reqSel?.length > 1 ? false : true,
    }));
    setFilteredList(reqList);
  };

  const handleAddNewBatch = () => {
    const batchList = [
      ...(productValues?.batchList ?? []),
      { ...initBatch, i: productValues?.batchList?.length ?? 0 },
    ];
    setBatchValues(initBatch);
    setProductValues({
      ...productValues,
      isBatchEdit: true,
      batchList,
      activeBatchIndex: productValues?.batchList?.length ?? 0,
    });
  };

  const onCloseBatchEdit = () => {
    let reqBatchList = productValues?.batchList;
    if (
      batchValues?.batchNumber === "" &&
      batchValues?.manufacturingDate === null &&
      batchValues?.expiryDate === null &&
      batchValues?.location === null &&
      batchValues?.quantity === "" &&
      batchValues?.subunits === "" &&
      batchValues?.unitSellingPrice === "" &&
      batchValues?.landedCost === ""
    ) {
      reqBatchList = reqBatchList
        ?.filter((bat) => bat?.i !== productValues?.activeBatchIndex)
        ?.map((li, i) => ({ ...li, i }));
    }
    setProductValues({
      ...productValues,
      batchList: reqBatchList,
      isBatchEdit: false,
      activeBatchIndex: null,
    });
  };

  const handleBatchValidationCheck = () => {
    let hlp = {},
      err = {};
    batchRequiredFields?.forEach((fld) => {
      const reqValue =
        typeof batchValues?.[fld] === "object"
          ? batchValues?.[fld]?.value
          : batchValues?.[fld];
      if (typeof reqValue === "number" ? false : !reqValue) {
        err = {
          ...err,
          [fld]:
            fld === "unitSellingPrice"
              ? productValues?.product?.billable
                ? true
                : false
              : true,
        };
        hlp = {
          ...hlp,
          [fld]:
            fld === "unitSellingPrice"
              ? productValues?.product?.billable
                ? "This is required field"
                : ""
              : "This is required field",
        };
      }
    });
    setBatchHelps(hlp);
    setBatchErrs(err);
    return Object.values(err).some((item) => item);
  };

  const handleSaveBatch = () => {
    if (handleBatchValidationCheck()) return;
    const reqBatchList = productValues?.batchList?.map((bat) => {
      if (bat?.i === productValues?.activeBatchIndex) {
        const reqObj = {
          ...bat,
          i: bat?.i,
          batchNumber: batchValues?.batchNumber,
          manufacturingDate: batchValues?.manufacturingDate,
          expiryDate: batchValues?.expiryDate,
          location: batchValues?.location,
          quantity: batchValues?.quantity,
          subunits: batchValues?.subunits,
          unitSellingPrice: batchValues?.unitSellingPrice,
          landedCost: batchValues?.landedCost,
        };
        return reqObj;
      }
      return bat;
    });
    setBatchValues({});
    setBatchErrs({});
    setBatchHelps({});
    setProductValues({
      ...productValues,
      batchList: reqBatchList,
      activeBatchIndex: null,
      isBatchEdit: false,
    });
  };

  const handleBatchChange = (name, value) => {
    let reqObj = { ...batchValues, [name]: value };
    const reqValue = typeof value === "object" ? value?.value : value;
    if (name === "quantity") {
      reqObj.subunits =
        Number(productValues?.product?.conversionFactor) * Number(value);
      // if (!selectedItem) {
      reqObj.landedCost =
        Number(productValues?.product?.itemTotal ?? 0) /
        (Number(productValues?.product?.conversionFactor ?? 0) *
          Number(value ?? 0));
      // }
    }
    if (name === "unitSellingPrice") {
      reqObj.oldSellingPrice = value;
    }
    setBatchValues(reqObj);
    const reqErrs = {
      ...batchErrs,
      [name]:
        reqValue?.length > 0
          ? false
          : batchRequiredFields?.includes(name)
            ? true
            : false,
    };

    const reqHelps = {
      ...batchHelps,
      [name]:
        reqValue?.length > 0
          ? ""
          : batchRequiredFields?.includes(name)
            ? "This is required field"
            : "",
    };
    if (name === "quantity" && reqValue?.length > 0) {
      reqHelps.subunits = "";
      reqErrs.subunits = false;
    }
    setBatchHelps(reqHelps);
    setBatchErrs(reqErrs);
  };

  const handleBatchEdit = (batch) => {
    const reqBatch = batch;
    const reqObj = {
      ...batchValues,
      batchNumber: reqBatch?.batchNumber,
      manufacturingDate: reqBatch?.manufacturingDate,
      expiryDate: reqBatch?.expiryDate,
      location: batch?.location,
      quantity: reqBatch?.quantity,
      subunits: reqBatch?.subunits,
      unitSellingPrice: Number(reqBatch?.unitSellingPrice)?.toFixed(2),
      landedCost: Number(reqBatch?.landedCost)?.toFixed(2),
    };
    setBatchValues(reqObj);
    setProductValues({
      ...productValues,
      activeBatchIndex: batch?.i,
      isBatchEdit: true,
    });
  };

  return (
    <>
      <div className="com-mar back-white pv10">
        <div className="flex-row-ali-cen w100Per">
          <div className="flex-center w100Per">
            <div className="flex-row-ali-cen">
              <div style={{ width: "400px" }}>
                <CustomTextField
                  placeholder="Search"
                  fullWidth
                  backgroundColor={AppColors.lightPink}
                  value={searchValue}
                  handleChange={(e) => setSearchValue(e.target.value)}
                />
              </div>
              <div className="ml10">
                <SplitButton list={["Delete"]} handleClickItem={handleAction} />
              </div>
            </div>
          </div>
          <div style={{ position: "absolute", left: 70 }} onClick={handleBack}>
            <div className="flex-row-ali-cen cursor">
              <ArrowBackIcon
                sx={{ color: AppColors.appPrimary, width: 20, height: 20 }}
              />
              <Typography className="fs16 txt-semi-bold blue-color ml5">
                Back
              </Typography>
            </div>
          </div>
          <div className="pos-absolute r80">
            <Typography className="font-medium fs16">
              Total: {pendingStocks?.totalRecords}
            </Typography>
          </div>
        </div>
        <Box className="pb-40 ph20">
          <TableContainer sx={{ maxHeight: 400 }} className="mb20">
            <Table
              sx={{ minWidth: 200 }}
              aria-labelledby="tableTitle"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {stckEntTblHdrs?.map((hdr, i) => (
                    <TableCell
                      style={tblGrayBack}
                      className={`table-header-text`}
                    >
                      <div
                        style={{
                          width:
                            hdr === "selected"
                              ? 10
                              : hdr === "hsnSacCode" || hdr === "name"
                                ? 120
                                : hdr === "quantity" ||
                                    hdr === "cgst" ||
                                    hdr === "sgst"
                                  ? 50
                                  : hdr === "taxes" || hdr === "itemTotal"
                                    ? 80
                                    : hdr === "landedCost"
                                      ? 100
                                      : 70,
                        }}
                      >
                        {hdr === "selected" ? (
                          <CustomCheckbox
                            checked={filteredList?.every(
                              (li) => li?.selected === true,
                            )}
                            onChange={handleCheckAll}
                          />
                        ) : (
                          nmeExpan?.[hdr]
                        )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              {filteredList?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={12} className="text-align-center h100">
                    <div className="no-rec">No records available</div>
                  </TableCell>
                </TableRow>
              )}

              <TableBody>
                {filteredList?.map((li, ind) => {
                  return (
                    <TableRow>
                      {stckEntTblHdrs?.map((hdr, i) => (
                        <TableCell key={ind + i + "tr"} component="th">
                          <div
                            style={{
                              width:
                                hdr === "selected"
                                  ? 10
                                  : hdr === "hsnSacCode" || hdr === "name"
                                    ? 120
                                    : hdr === "quantity" ||
                                        hdr === "cgst" ||
                                        hdr === "sgst"
                                      ? 50
                                      : hdr === "taxes" || hdr === "itemTotal"
                                        ? 80
                                        : hdr === "landedCost"
                                          ? 100
                                          : 70,
                            }}
                          >
                            {hdr === "selected" ? (
                              <CustomCheckbox
                                checked={li?.selected}
                                onChange={() =>
                                  handleChangeCheckBox(!li?.selected, ind)
                                }
                              />
                            ) : i === stckEntTblHdrs?.length - 1 ? (
                              <div className="flex-row-ali-cen">
                                <img
                                  src={require("../../../assets/images/png/delete.png")}
                                  className="imghw30 cursor"
                                  onClick={() => handleDeleteRow(li)}
                                />
                                {
                                  <img
                                    src={require("../../../assets/images/png/imgAttach.png")}
                                    className="imghw30 cursor ml20"
                                    onClick={() => handleUploadInventry(li)}
                                  />
                                }
                              </div>
                            ) : hdr === "name" ? (
                              <Custom3dotString
                                str={li?.[hdr]}
                                className="font-regular fs14"
                              />
                            ) : hdr === "taxes" || hdr === "itemTotal" ? (
                              Number(li?.[hdr])?.toFixed(2)
                            ) : (
                              li?.[hdr]
                            )}
                          </div>
                        </TableCell>
                      ))}
                    </TableRow>
                  );
                })}
              </TableBody>

              {Math.ceil(pendingStocks?.totalRecords / itemSize) > 1 ? (
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="flex-end">
                        <Pagination
                          count={Math.ceil(
                            pendingStocks?.totalRecords / itemSize,
                          )}
                          variant="outlined"
                          color="primary"
                          page={page}
                          onChange={handleChangePage}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              ) : null}
            </Table>
          </TableContainer>
        </Box>
      </div>

      <CustomModal
        open={invntUpdModVsble}
        onClose={handleCloseInvntUpload}
        header="Inventory Upload"
        headerCenter
        modalWidth={50}
        modal
      >
        <Grid container spacing={2}>
          {inventFiles?.length ? (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt20">
              <FilesWithCloseButton
                files={inventFiles}
                onClickFile={(i, fle) => handleInventImageRemove(i)}
                center
              />
            </Grid>
          ) : null}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomUpload
              onUploadFile={onUploadFile}
              multipleNew
              fileAccept="image/*"
              multiFiles
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-center">
              <div>
                <CustomButton
                  text="Submit"
                  smallBtn
                  onClick={onInventoryUpload}
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </CustomModal>
      <CustomModal
        open={delModVsble}
        onClose={handleCloseDelMod}
        header="Delete Product"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to Delete the selected Product?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={handleConfirmDelete}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={handleCloseDelMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={prdctPrevModVsble}
        onClose={onClosePrevMod}
        header="Preview"
        headerCenter
        modalWidth={100}
        modal
      >
        <div className="ph20 scroll-80vh">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-bold fs16 blue-color">
                Product Details
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomCheckbox
                label="Active"
                checked={productValues?.product?.active}
                onChange={() =>
                  handleChange("active", !productValues?.product?.active)
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <div>
                  <CustomCheckbox
                    label="Billable"
                    checked={productValues?.product?.billable}
                    onChange={() =>
                      handleChange(
                        "billable",
                        !productValues?.product?.billable,
                      )
                    }
                  />
                </div>
                <div className="ml20">
                  <CustomCheckbox
                    label="Auto-consumed"
                    checked={productValues?.product?.autoConsumed}
                    onChange={() =>
                      handleChange(
                        "autoConsumed",
                        !productValues?.product?.autoConsumed,
                      )
                    }
                  />
                </div>
              </div>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomCheckbox
                label="Disabled"
                checked={productValues?.product?.active}
                onChange={() =>
                  handleChange("active", !productValues?.product?.active)
                }
              />
            </Grid> */}
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">SKU ID</div>
              <CustomTextField
                name="skuId"
                fullWidth
                value={productValues?.product?.skuId}
                error={productErrors?.skuId}
                helperText={productHelps?.skuId}
                handleChange={(e) => handleChange("skuId", e?.target?.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Category <span className="red-color">*</span>
              </div>
              <Select
                list={productCategoryList}
                value={productValues?.product?.category}
                handleChange={(e, value) => handleChange("category", value)}
                name="category"
                search
                error={productErrors?.category}
                helperText={productHelps?.category}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Subcategory <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="subCategory"
                fullWidth
                value={productValues?.product?.subCategory}
                error={productErrors?.subCategory}
                helperText={productHelps?.subCategory}
                handleChange={(e) =>
                  handleChange("subCategory", e?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">HSN Code</div>
              <CustomTextField
                name="hsnSacCode"
                fullWidth
                value={productValues?.product?.hsnSacCode}
                error={productErrors?.hsnSacCode}
                helperText={productHelps?.hsnSacCode}
                handleChange={(e) =>
                  handleChange("hsnSacCode", e?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Name <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="name"
                fullWidth
                value={productValues?.product?.name}
                error={productErrors?.name}
                helperText={productHelps?.name}
                handleChange={(e) => handleChange("name", e?.target?.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Trade Name <span className="red-color">*</span>
              </div>
              <CustomTextField
                name="tradeName"
                fullWidth
                value={productValues?.product?.tradeName}
                error={productErrors?.tradeName}
                helperText={productHelps?.tradeName}
                handleChange={(e) =>
                  handleChange("tradeName", e?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Major Active Ingredients
              </div>
              <CustomTextField
                name="ingredient"
                fullWidth
                value={productValues?.product?.ingredient}
                error={productErrors?.ingredient}
                helperText={productHelps?.ingredient}
                handleChange={(e) =>
                  handleChange("ingredient", e?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Nature</div>
              <CustomTextField
                name="nature"
                fullWidth
                value={productValues?.product?.nature}
                error={productErrors?.nature}
                helperText={productHelps?.nature}
                handleChange={(e) => handleChange("nature", e?.target?.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Bar Code number
              </div>
              <CustomTextField
                name="code"
                fullWidth
                value={productValues?.product?.code}
                error={productErrors?.code}
                helperText={productHelps?.code}
                handleChange={(e) => handleChange("code", e?.target?.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Brand</div>
              <CustomTextField
                name="brand"
                fullWidth
                value={productValues?.product?.brand}
                error={productErrors?.brand}
                helperText={productHelps?.brand}
                handleChange={(e) => handleChange("brand", e?.target?.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Reorder level</div>
              <CustomTextField
                name="reorderLevel"
                fullWidth
                value={productValues?.product?.reorderLevel}
                error={productErrors?.reorderLevel}
                helperText={productHelps?.reorderLevel}
                handleChange={(e) =>
                  handleChange("reorderLevel", e?.target?.value)
                }
              />
            </Grid>
            {/* ['deworming','Flea & Tick Treatment','Fluid
            Therapy','Medication',"OTC Products","Other Parasite Treatment"
            ,"Vaccines"] */}
            {drugScheduleShowCategoryList?.includes(
              productValues?.product?.category?.value?.toLowerCase(),
            ) ? (
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <div className="txt-semi-bold fs14 light-grey">
                  Drug Schedule
                </div>
                <Select
                  list={drugScheduleList}
                  value={productValues?.product?.drugSchedule}
                  handleChange={(e, value) =>
                    handleChange("drugSchedule", value)
                  }
                  name="drugSchedule"
                  search
                  error={productErrors?.drugSchedule}
                  helperText={productHelps?.drugSchedule}
                />
              </Grid>
            ) : null}
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Purchase UOM</div>
              <CustomTextField
                name="purchaseUom"
                fullWidth
                value={productValues?.product?.purchaseUom}
                error={productErrors?.purchaseUom}
                helperText={productHelps?.purchaseUom}
                handleChange={(e) =>
                  handleChange("purchaseUom", e?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Sales UOM</div>
              <CustomTextField
                name="salesUom"
                fullWidth
                value={productValues?.product?.salesUom}
                error={productErrors?.salesUom}
                helperText={productHelps?.salesUom}
                handleChange={(e) => handleChange("salesUom", e?.target?.value)}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                UOM Conversion Factor
              </div>
              <CustomTextField
                name="conversionFactor"
                fullWidth
                value={productValues?.product?.conversionFactor}
                error={productErrors?.conversionFactor}
                helperText={productHelps?.conversionFactor}
                handleChange={(e) =>
                  handleChange("conversionFactor", e?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">
                Administered UOM
              </div>
              <div className="flex-row">
                <div className="w60Per pr10">
                  <CustomTextField
                    name="packageUom"
                    fullWidth
                    value={productValues?.product?.packageUom}
                    error={productErrors?.packageUom}
                    helperText={productHelps?.packageUom}
                    handleChange={(e) =>
                      handleChange("packageUom", e?.target?.value)
                    }
                    type="number"
                  />
                </div>
                <div className="w40Per">
                  <Select
                    list={administeredUOMList}
                    value={productValues?.product?.adminUom}
                    handleChange={(e, value) => handleChange("adminUom", value)}
                    name="adminUom"
                    search
                    error={productErrors?.adminUom}
                    helperText={productHelps?.adminUom}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <div className="txt-semi-bold fs14 light-grey">Dosage</div>
              <div className="flex-row">
                <div className="w60Per pr10">
                  <CustomTextField
                    name="dosage"
                    // label="Dosage"
                    fullWidth
                    value={productValues?.product?.dosage}
                    error={productErrors?.dosage}
                    helperText={productHelps?.dosage}
                    handleChange={(e) =>
                      handleChange("dosage", e?.target?.value)
                    }
                    type="number"
                    endIcon
                    inputIcon={
                      <Custom3dotString
                        str={productValues?.product?.adminUom?.name ?? ""}
                        length={9}
                        className="fs12 font-medium"
                      />
                    }
                  />
                </div>
                <div className="w40Per">
                  <Select
                    list={dosageTypes}
                    value={productValues?.product?.dosageType}
                    handleChange={(e, value) =>
                      handleChange("dosageType", value)
                    }
                    name="dosageType"
                    search
                    error={productErrors?.dosageType}
                    helperText={productHelps?.dosageType}
                  />
                </div>
              </div>
            </Grid>
            {productValues?.product?.billable ? (
              <>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    CGST (%) <span className="red-color">*</span>
                  </div>
                  <CustomTextField
                    name="cgst"
                    fullWidth
                    value={productValues?.product?.cgst}
                    error={productErrors?.cgst}
                    helperText={productHelps?.cgst}
                    handleChange={(e) => handleChange("cgst", e?.target?.value)}
                    type="number"
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    SGST (%) <span className="red-color">*</span>
                  </div>
                  <CustomTextField
                    name="sgst"
                    fullWidth
                    value={productValues?.product?.sgst}
                    error={productErrors?.sgst}
                    helperText={productHelps?.sgst}
                    handleChange={(e) => handleChange("sgst", e?.target?.value)}
                    type="number"
                  />
                </Grid>
              </>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Brief Description of the Product
              </div>
              <CustomTextField
                name="description"
                fullWidth
                value={productValues?.product?.description}
                error={productErrors?.description}
                helperText={productHelps?.description}
                handleChange={(e) =>
                  handleChange("description", e?.target?.value)
                }
                multiline
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <Typography className="font-bold fs16 blue-color">
                  Batch Details
                </Typography>
                {productValues?.isBatchEdit ? (
                  <>
                    <div className="ml10">
                      <CustomButton
                        text="Save"
                        onClick={handleSaveBatch}
                        smallBtn
                      />
                    </div>
                    <div className="ml10">
                      <CustomButton
                        text="Discard"
                        onClick={onCloseBatchEdit}
                        redBtn
                        smallBtn
                      />
                    </div>
                  </>
                ) : (
                  <div
                    className="flex-row-ali-cen cursor ml10"
                    onClick={handleAddNewBatch}
                  >
                    <div className="flex-center plus-icon">
                      <AddIcon sx={addIcon} />
                    </div>
                    <Typography className="blue-color fs16 ml5 font-bold">
                      Add
                    </Typography>
                  </div>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row scrollx scroll-hor">
                {!productValues?.isBatchEdit &&
                  productValues?.batchList?.length > 0 &&
                  (productValues?.batchList ?? [])?.map((sb, i) => (
                    <div
                      className={`blue-box-examD ${i !== 0 ? "ml20" : ""}`}
                      style={{ width: 400, flexShrink: 0 }}
                      key={sb?.batchId}
                    >
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 blue-color">
                          Batch Number :{" "}
                        </Typography>
                        <Typography className="txt-semi-bold fs14 black20 ml5">
                          {sb?.batchNumber ?? ""}
                        </Typography>
                        <div className="flex1-end">
                          <div
                            className="cursor"
                            onClick={() => handleBatchEdit(sb)}
                          >
                            <div className="flex-center">
                              <EditIcon sx={plusBtn} />
                            </div>
                            <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                              Edit
                            </Typography>
                          </div>
                        </div>
                      </div>
                      <div className="flex-row">
                        <div className="w50Per">
                          <div className="flex-row-ali-cen">
                            <div className="gray-dot" />
                            <Typography className="font-medium fs12 blue-color ml5">
                              Mfg Date :{" "}
                            </Typography>
                            <Typography className="font-medium fs12 black20 ml5">
                              {sb?.manufacturingDate
                                ? moment(
                                    new Date(sb?.manufacturingDate),
                                  ).format("YYYY-MM-DD")
                                : null}
                            </Typography>
                          </div>
                          <div className="flex-row-ali-cen">
                            <div className="gray-dot" />
                            <Typography className="font-medium fs12 blue-color ml5">
                              Unit Qty :{" "}
                            </Typography>
                            <Typography className="font-medium fs12 black20 ml5">
                              {sb?.quantity}
                            </Typography>
                          </div>
                          <div className="flex-row-ali-cen">
                            <div className="gray-dot" />
                            <Typography className="font-medium fs12 blue-color ml5">
                              Selling Price :{" "}
                            </Typography>
                            <Typography className="font-medium fs12 black20 ml5">
                              {sb?.unitSellingPrice
                                ? Number(sb?.unitSellingPrice)?.toFixed(2)
                                : ""}
                            </Typography>
                          </div>
                        </div>
                        <div className="w50Per">
                          <div className="flex-row-ali-cen">
                            <div className="gray-dot" />
                            <Typography className="font-medium fs12 blue-color ml5">
                              Expiry Date :{" "}
                            </Typography>
                            <Typography className="font-medium fs12 black20 ml5">
                              {sb?.expiryDate
                                ? moment(new Date(sb?.expiryDate)).format(
                                    "YYYY-MM-DD",
                                  )
                                : null}
                            </Typography>
                          </div>
                          <div className="flex-row-ali-cen">
                            <div className="gray-dot" />
                            <Typography className="font-medium fs12 blue-color ml5">
                              Subunit Qty :{" "}
                            </Typography>
                            <Typography className="font-medium fs12 black20 ml5">
                              {sb?.subunits ?? ""}
                            </Typography>
                          </div>
                          <div className="flex-row-ali-cen">
                            <div className="gray-dot" />
                            <Typography className="font-medium fs12 blue-color ml5">
                              Landed Cost :{" "}
                            </Typography>
                            <Typography className="font-medium fs12 black20 ml5">
                              {sb?.landedCost
                                ? Number(sb?.landedCost)?.toFixed(2)
                                : ""}
                            </Typography>
                          </div>
                        </div>
                      </div>
                      <div className="flex-row-ali-cen">
                        <div className="gray-dot" />
                        <Typography className="font-medium fs12 blue-color ml5">
                          Location :{" "}
                        </Typography>
                        <Typography className="font-medium fs12 black20 ml5">
                          {typeof sb?.location === "object" &&
                          sb?.location !== null
                            ? (sb?.location?.name ?? sb?.location?.value ?? "")
                            : (sb?.location ?? "")}
                        </Typography>
                      </div>
                    </div>
                  ))}
              </div>
            </Grid>
            {productValues?.isBatchEdit && (
              <>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Batch Number
                  </div>
                  <CustomTextField
                    name="batchNumber"
                    fullWidth
                    value={batchValues?.batchNumber}
                    error={batchErrs?.batchNumber}
                    helperText={batchHelps?.batchNumber}
                    handleChange={(e) =>
                      handleBatchChange("batchNumber", e?.target?.value)
                    }
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">Mfg Date</div>
                  <CustomTextField
                    fullWidth
                    value={batchValues?.manufacturingDate}
                    error={batchErrs?.manufacturingDate}
                    helperText={batchHelps?.manufacturingDate}
                    handleChange={(e) =>
                      handleBatchChange("manufacturingDate", e?.target?.value)
                    }
                    mobileDate
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Expiry Date
                  </div>
                  <CustomTextField
                    fullWidth
                    value={batchValues?.expiryDate}
                    error={batchErrs?.expiryDate}
                    helperText={batchHelps?.expiryDate}
                    handleChange={(e) =>
                      handleBatchChange("expiryDate", e?.target?.value)
                    }
                    mobileDate
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Location <span className="red-color">*</span>
                  </div>
                  <Select
                    list={getLocationList()}
                    value={batchValues?.location}
                    handleChange={(e, value) =>
                      handleBatchChange("location", value)
                    }
                    name="location"
                    search
                    error={batchErrs?.location}
                    helperText={batchHelps?.location}
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Unit Qty {/* Quantity */}
                    <span className="red-color">*</span>
                  </div>
                  <CustomTextField
                    name="quantity"
                    fullWidth
                    value={batchValues?.quantity}
                    error={batchErrs?.quantity}
                    helperText={batchHelps?.quantity}
                    handleChange={(e) =>
                      handleBatchChange("quantity", e?.target?.value)
                    }
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Subunit Qty {/* Subunits */}
                    <span className="red-color">*</span>
                  </div>
                  <CustomTextField
                    name="subunits"
                    fullWidth
                    value={batchValues?.subunits}
                    error={batchErrs?.subunits}
                    helperText={batchHelps?.subunits}
                    handleChange={(e) =>
                      handleBatchChange("subunits", e?.target?.value)
                    }
                    disabled
                  />
                </Grid>
                {productValues?.product?.billable ? (
                  <>
                    <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                      <div className="txt-semi-bold fs14 light-grey">
                        Selling Price {/* Unit Selling Price (MRP){" "} */}
                        <span className="red-color">*</span>
                      </div>
                      <CustomTextField
                        name="unitSellingPrice"
                        fullWidth
                        value={batchValues?.unitSellingPrice}
                        error={batchErrs?.unitSellingPrice}
                        helperText={batchHelps?.unitSellingPrice}
                        handleChange={(e) =>
                          handleBatchChange(
                            "unitSellingPrice",
                            e?.target?.value,
                          )
                        }
                      />
                      <div className="fs12 gray-color txt-regular mt5">
                        Price is for subunits
                      </div>
                    </Grid>

                    {/* <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Item Total (Buying) <span className="red-color">*</span>
                  </div>
                  <CustomTextField
                    name="itemTotal"
                    fullWidth
                    value={productValues?.product?.itemTotal}
                    error={productErrors?.itemTotal}
                    helperText={productHelps?.itemTotal}
                    handleChange={(e) =>
                      handleChange("itemTotal", e?.target?.value)
                    }
                    disabled
                  />
                </Grid> */}
                    <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                      <div className="txt-semi-bold fs14 light-grey">
                        Landed Cost (Buying)
                        {/* <span className="red-color">*</span> */}
                      </div>
                      <CustomTextField
                        name="landedCost"
                        fullWidth
                        value={Number(batchValues?.landedCost)}
                        error={batchErrs?.landedCost}
                        helperText={batchHelps?.landedCost}
                        handleChange={(e) =>
                          handleBatchChange("landedCost", e?.target?.value)
                        }
                        disabled
                      />
                    </Grid>
                  </>
                ) : null}
              </>
            )}
          </Grid>

          <div className="mt30">
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <div className="flex1-center">
                <div className="flex-row-ali-cen">
                  {/* <div className="mr10">
                    <CustomButton
                      text="Cancel"
                      textBtn
                      onClick={onClosePrevMod}
                      color={AppColors.red}
                    />
                  </div> */}
                  <div className="ml10">
                    <CustomButton
                      text="Submit"
                      onClick={handleSubmit}
                      smallBtn
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default StockPendingTable;
